import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationDeleteResourceArgs,
  BackendPerformanceCenterCustomerResource,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteResource($id: ID!) {
    deleteResource(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteResourceArgs;
type Result = Pick<BackendPerformanceCenterCustomerResource, 'id'>;

export const deleteResource = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
